import React, { useEffect, useState } from "react";

import "../../assets/css/dashboard.css";
import myasset from "../../assets/icons/fi_621995.svg";
import myassethover from "../../assets/icons/fi_621995hover.svg";
import config from "../../assets/icons/wrench1.svg";
import confighover from "../../assets/icons/wrench1 copy.svg";
import arrowVector from "../../assets/icons/arrow-Vector.svg";
import heroicons_arrowlongleft1 from "../../assets/icons/heroicons_arrow-long-left1.svg";
import models from "../../assets/icons/models.svg";
import modelshover from "../../assets/icons/modelshover.svg";


import tags from "../../assets/icons/tags.svg";
import fi_3388671hover from "../../assets/icons/fi_3388671hover.svg";
import thinking1 from "../../assets/icons/thinking1.svg";
import userwhite from "../../assets/icons/userwhite.svg";

import templathover from "../../assets/icons/fi_1828824hover.svg";
import template from "../../assets/icons/fi_1828824.svg";


import majesticons_arrowright from "../../assets/icons/majesticons_arrow-right.svg";

import ArrowUp from "../../assets/icons2/ArrowUp.svg";
import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import { Link, useNavigate } from "react-router-dom";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";


const Dashboard = () => {
  const [asset_id, setAssetId] = useState(null);


  const [equipments, setEquipments] = useState([]);
  const [assetAttribute, setAssetAttribute] = useState([]);
  const [totalItems, setTotalItems] = useState(0);

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [statusFilter, setStatusFilter] = useState("");

  const [assets, setAssets] = useState([]);
  const [counts, setcounts] = useState([]);

  const navigate = useNavigate();

  const [sortBy, setSortBy] = useState({
    field: "created_at",
    order: "asc",
  });

  useEffect(() => {
    const getAssetClass = async () => {
      try {
        const data = await fetchWrapper(
          `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/getall`,
          {
            method: "POST",
            body: JSON.stringify({}),
          }
        );

        // Proceed with handling the data here

        setAssets(data || []); // Update state or perform other actions
      } catch (error) {
        console.error("Error fetching data:", error.message);
        if (error.message === "Unauthorized") {
          navigate("/auth/login");
        }
      }
    };

    getAssetClass();
  }, [navigate]);

  useEffect(() => {
    const getCount = async () => {
      try {
        const response = await fetchWrapper(
          `${process.env.REACT_APP_BASE_API_URL1}/api/v1/count`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          }
        );

        // if (!response.ok) {
        //   throw new Error("Failed to fetch data from the collection.");
        // }
        // const data = await response.json();
        setcounts(response || []);

      } catch (error) {
        console.error("Error fetching data:", error.message);
        if (error.message === "Unauthorized") {
          navigate("/auth/login");
        }
      }
    };
    getCount();
  }, []);

  const fetchEquipments = async (asset_id1) => {
    try {
      setAssetId(asset_id1);
      const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&status=${statusFilter}`;
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/${asset_id1}/paginate${queryString}`;



      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}), // Add an empty body if required by your API
        },
        navigate
      );

      // Directly use the data without checking response.ok again

      updateDynamicColumns(data.equipments);
      setAssetAttribute(data.assetAttribute);

      setEquipments(data.equipments);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);
      setSearch("")
      setPage("");
      setStatusFilter("");
      setPageSize(10);

    } catch (error) {
      console.error("Error fetching equipments:", error);
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
      }
    }
  };

  const updateDynamicColumns = (data) => {
    if (data.length > 0) {
      // const columns = Object.keys(data[0]);
      // setDynamicColumns(columns);
    }
  };

  const visibleColumns = assetAttribute.filter((field) => {
    return equipments.some(
      (equipment) =>
        equipment[field.field_name] !== undefined &&
        equipment[field.field_name] !== null
    );
  });

  // const handleSortChange = (field) => {
  //   setSortBy((prevSort) => ({
  //     field,
  //     order:
  //       prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
  //   }));
  // };

  const handleSortChange = (field) => {
    setSortBy((prevSort) => {
      const newSort = {
        field,
        order:
          prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
      };

      return newSort;
    });
  };

  // const handleSortChange = (field) => {
  //   setSortBy((prevSort) => ({
  //     field,
  //     order:
  //       prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
  //   }));
  // };

  const truncateText = (text, maxChars) => {
    if (text.length > maxChars) {
      return text.slice(0, maxChars) + "...";
    }
    return text;
  };

  useEffect(() => {
    if (asset_id) {
      fetchEquipments(asset_id);
    }
  }, [
    page,
    pageSize,
    sortBy,
    search,
    totalPages,
    currentPage,
    totalItems,
    statusFilter,
    equipments.length,
  ]);

  return (
    <div className="container">
      <div className="pt-3">
        <h5 className="dashboard">Dashboard</h5>
        <nav className="show-breadcrumb breadcrumb-nav" aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#" style={{ textDecoration: "none" }}>
                Home
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Dashboard
            </li>
          </ol>
        </nav>
      </div>

      <div className="dashboard-nav pt-2">
        <div className="row card-border">
          <div className="col-md-4 col-lg-2 col-6 p-0 card-tab">
            <Link
              to="/users"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="menu-card card1-border border-r border-btm">
                <img
                  className="non-hover"
                  src={userwhite}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <img
                  className="on-hover"
                  src={thinking1}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <h3>{counts.users} Users</h3>
                <img
                  className="arrow-bg"
                  src={arrowVector}
                  height="40px"
                  width="40px"
                  alt="Templates Icon"
                />
                <img
                  className="arrow-bg-hover"
                  src={heroicons_arrowlongleft1}
                  alt="Templates Icon"
                />
              </div>
            </Link>
          </div>

          <div className="col-md-4 col-lg-2 col-6 p-0 card-tab">
            <Link
              to="/master"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="menu-card border-r border-btm">
                <img
                  className="non-hover"
                  src={config}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <img
                  className="on-hover"
                  src={confighover}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <h3>{counts.masters} Masters</h3>
                <img
                  className="arrow-bg"
                  src={arrowVector}
                  height="40px"
                  width="40px"
                  alt="Templates Icon"
                />
                <img
                  className="arrow-bg-hover"
                  src={heroicons_arrowlongleft1}
                  alt="Templates Icon"
                />
              </div>
            </Link>
          </div>

          {/***

            <div className="col-md-4 col-lg-2 col-6 p-0 ">
            <div className="menu-card border-r border-y nav-link disabled tab-active">
              <img
                src={models}
                height="28px"
                width="28px"
                alt="Templates Icon"
              />
              <h3>80 Models</h3>
              <img
                className="arrow-bg"
                src={heroicons_arrowlongleft1}
                height="40px"
                width="40px"
                alt="Templates Icon"
              />
            </div>
          </div>
          */}

          <div className="col-md-4 col-lg-2 col-6 p-0 card-tab">
            <Link
              to="/template_types/6655aba8c7b0a5ca7827ed7f"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="menu-card border-r border-btm">
                <img
                  className="non-hover"
                  src={template}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <img
                  className="on-hover"
                  src={templathover}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <h3>{counts.templates} Templates</h3>
                <img
                  className="arrow-bg"
                  src={arrowVector}
                  height="40px"
                  width="40px"
                  alt="Templates Icon"
                />
                <img
                  className="arrow-bg-hover"
                  src={heroicons_arrowlongleft1}
                  alt="Templates Icon"
                />
              </div>
            </Link>
          </div>
          <div className="col-md-4 col-lg-2 col-6 p-0 card-tab">
            <Link
              to="/asset_list"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="menu-card border-r border-btm">
                <img
                  className="non-hover"
                  src={tags}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <img
                  className="on-hover"
                  src={fi_3388671hover}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <h3>{counts.assets} Assets</h3>
                <img
                  className="arrow-bg"
                  src={arrowVector}
                  height="40px"
                  width="40px"
                  alt="Templates Icon"
                />
                <img
                  className="arrow-bg-hover"
                  src={heroicons_arrowlongleft1}
                  alt="Templates Icon"
                />
              </div>
            </Link>
          </div>
          <div className="col-md-4 col-lg-2 col-6 p-0 card-tab">
            <Link
              to="/model_list"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="menu-card border-x border-r border-btm">
                <img
                  className="non-hover"
                  src={models}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <img
                  className="on-hover"
                  src={modelshover}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <h3> {counts.models} Models</h3>
                <img
                  className="arrow-bg"
                  src={arrowVector}
                  height="40px"
                  width="40px"
                  alt="Templates Icon"
                />
                <img
                  className="arrow-bg-hover"
                  src={heroicons_arrowlongleft1}
                  alt="Templates Icon"
                />
              </div>
            </Link>
          </div>
          <div className="col-md-4 col-lg-2 col-6 p-0 card-tab">
            <Link
              to="/all_assets"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="menu-card border-l border-btm">
                <img
                  className="non-hover"
                  src={myasset}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <img
                  className="on-hover"
                  src={myassethover}
                  height="28px"
                  width="28px"
                  alt="Templates Icon"
                />
                <h3>{counts.equipments} Equipments</h3>
                <img
                  className="arrow-bg"
                  src={arrowVector}
                  height="40px"
                  width="40px"
                  alt="Templates Icon"
                />
                <img
                  className="arrow-bg-hover"
                  src={heroicons_arrowlongleft1}
                  alt="Templates Icon"
                />
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* <HighChartComponent /> */}

      {/***
     <div className="graph-body pt-5">
        <div className="row gap-5">
          <div className="col set-1">
            <div className="card-header1">
              <h5 className="m-0">Data Set-1</h5>
            </div>
            <div className="graph-1">
              <div className="d-flex justify-content-between">
                <h6 className="m-0">Total Users</h6>
                <ul className="d-flex gap-2 m-0">
                  <li className="border-line">Operating Status&nbsp;</li>
                  <li><img src="assets/icons/year-color.svg" alt="" /> &nbsp;This year</li>
                  <li><img src="assets/icons/last-year.svg" alt="" /> &nbsp;Last year</li>
                </ul>
              </div>
              <div className="graph-chart pt-4">
                <div className="container1">
                  <canvas id="myChart" width="600" height="400"></canvas>
                </div>
              </div>
            </div>
          </div>
          <div className="col set-1">
            <div className="card-header1">
              <h5 className="m-0">Data Set-2</h5>
            </div>
            <div className="graph-1">
              <div className="d-flex justify-content-between">
                <h6 className="m-0">Overall Analysis</h6>
                <ul className="d-flex gap-2 m-0">
                  <li className="border-line">Operating Status&nbsp;</li>
                  <li><img src="assets/icons/year-color.svg" alt="" /> &nbsp;This year</li>
                  <li><img src="assets/icons/last-year.svg" alt="" /> &nbsp;Last year</li>
                </ul>
              </div>
              <div className="graph-1">
                <div className="graph-chart pt-4">
                  <div className="chart-container">
                    <canvas id="stackedbarchart" width="600" height="400"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row gap-5 pt-5">
          <div className="col set-1">
            <div className="card-header1">
              <h5 className="m-0">Data Set-3</h5>
            </div>
            <div className="graph-1">
              <div className="graph-chart pt-4">
                <div className="container1 gap-3">
                  <div className="chart-container">
                    <canvas id="myDoughnutChart"></canvas>
                  </div>
                  <div className="table-container">
                    <h6>Analysis</h6>
                    <table id="dataTable">
                      <thead className="test-head">
                        <tr>
                          <th>Color</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody className="test-head1">

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col set-1">
            <div className="card-header1">
              <h5 className="m-0">Data Set-4</h5>
            </div>
            <div className="graph-1">
              <div className="d-flex justify-content-between">
                <h6 className="m-0">Overall Analysis</h6>
                <ul className="d-flex gap-2 m-0">
                  <li className="border-line">Operating Status&nbsp;</li>
                  <li><img src="assets/icons/year-color.svg" alt="" /> &nbsp;Data 1</li>
                  <li><img src="assets/icons/last-year.svg" alt="" /> &nbsp;Data 2</li>
                </ul>
              </div>
              <div className="graph-chart4 pt-4">
                <div className="container1 ">
                  <canvas id="myLineChart" width="600" height="400"></canvas>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    */}

      <div className=" justify-content-between title-line pt-4 dash-navbar">
        <h4 className="align-content-center m-0">&nbsp;Assets</h4>
        <div className="d-flex gap-3 buttons">
          <div className="dropdown">
            <div className="dropdown">
              <select
                id="cars"
                style={{ padding: "10px", width: "250px" }}
                className="select-unit textarea"
                onChange={(e) => fetchEquipments(e.target.value)}
              >
                <option value="">Select Asset Class</option>
                {assets.map((asset) => (
                  <option key={asset._id} value={asset._id}>
                    {asset.asset_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div id="overlay"></div>
          <div>
            <button
              type="button"
              id="openPopup"
              className="btn-bg"
              onClick={() => navigate("/all_assets")}
            >
              VIEW ALL{" "}
              <span className="arrow-white">
                {" "}
                <img src={majesticons_arrowright} alt="" />
              </span>
            </button>
            
          </div>
        </div>
      </div>

      {/* <div className="asset-table">
        <div className="table-responsive">
          <table className="table table-striped align-middle table-text">
            <thead className="table-head align-middle">
              <tr>
                <th className="col">
                  # ID <i className="fas fa-angle-up icon-up"></i>
                  <i className="fas fa-angle-down icon-down"></i>
                </th>
                <th className="col">
                  CODE <i className="fas fa-angle-up icon-up"></i>
                  <i className="fas fa-angle-down icon-down"></i>
                </th>
                <th className="col">
                  EQUIPMENT NAME{" "}
                  <i style={{ fontSize: "22px" }} className="fa">
                    &#xf176;
                  </i>
                </th>
                <th className="col">
                  SECTOR <i className="fas fa-angle-up icon-up"></i>
                  <i className="fas fa-angle-down icon-down"></i>
                </th>
                <th className="col">
                  TYPE &nbsp; <i className="fas fa-angle-up icon-up"></i>
                  <i className="fas fa-angle-down icon-down"></i>
                </th>
                <th className="col">GROUP</th>
                <th className="col">VARIABLES</th>
                <th className="col">STATUS</th>
                <th className="col">ACTION</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>01</td>
                <td>007</td>
                <td>Aeration Blower</td>
                <td>Cement</td>
                <td>Pumps</td>
                <td>Storage</td>
                <td>1</td>
                <td>
                  <span className="active-status">Active</span>
                </td>
                <td
                  className="justify-content-center align-content-center gap-btwn-action"
                  style={{ paddingTop: "12px" }}
                >
                  <div className="action-icons">
                    <span className="align-content-center">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup2" src={edit} />
                      </a>
                    </span>
                    <span className="align-content-center trash-px">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup1" src={trash} />
                      </a>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>01</td>
                <td>007</td>
                <td>Aeration Blower</td>
                <td>Cement</td>
                <td>Pumps</td>
                <td>Storage</td>
                <td>1</td>

                <td>
                  <span className="inactive">Inactive</span>
                </td>
                <td>
                  <div className="action-icons">
                    <span className="align-content-center">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup2" src={edit} />
                      </a>
                    </span>
                    <span className="align-content-center trash-px">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup1" src={trash} />
                      </a>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>01</td>
                <td>007</td>
                <td>Aeration Blower</td>
                <td>Cement</td>
                <td>Pumps</td>
                <td>Storage</td>
                <td>1</td>

                <td>
                  <span className="active-status">Active</span>
                </td>
                <td>
                  <div className="action-icons">
                    <span className="align-content-center">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup2" src={edit} />
                      </a>
                    </span>
                    <span className="align-content-center trash-px">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup1" src={trash} />
                      </a>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>01</td>
                <td>007</td>
                <td>Aeration Blower</td>
                <td>Cement</td>
                <td>Pumps</td>
                <td>Storage</td>
                <td>1</td>

                <td>
                  <span className="active-status">Active</span>
                </td>
                <td>
                  <div className="action-icons">
                    <span className="align-content-center">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup2" src={edit} />
                      </a>
                    </span>
                    <span className="align-content-center trash-px">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup1" src={trash} />
                      </a>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>01</td>
                <td>007</td>
                <td>Aeration Blower</td>
                <td>Cement</td>
                <td>Pumps</td>
                <td>Storage</td>
                <td>1</td>
                <td>
                  <span className="inactive">Inactive</span>
                </td>
                <td>
                  <div className="action-icons">
                    <span className="align-content-center">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup2" src={edit} />
                      </a>
                    </span>
                    <span className="align-content-center trash-px">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup1" src={trash} />
                      </a>
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>01</td>
                <td>007</td>
                <td>Aeration Blower</td>
                <td>Cement</td>
                <td>Pumps</td>
                <td>Storage</td>
                <td>1</td>

                <td>
                  <span className="inactive">Inactive</span>
                </td>
                <td>
                  <div className="action-icons">
                    <span className="align-content-center">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup2" src={edit} />
                      </a>
                    </span>
                    <span className="align-content-center trash-px">
                      <div id="overlay"></div>
                      <a href="#">
                        <img id="openPopup1" src={trash} />
                      </a>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> */}
      <div style={{ marginTop: "-10px" }}>
        <div className="table-responsive">
          <table className="table  align-middle table-text">
            <thead className="table-head align-middle">
              <tr>
                <th className="col">ID</th>
                {visibleColumns.map((field, index) => (
                  <th
                    className="col text-uppercase"
                    key={index}
                    onClick={() => handleSortChange(field.field_name)}
                  >
                    <span>
                      {field.display_name}{" "}
                      {sortBy.field === field.field_name && (
                        <span>
                          {sortBy.order === "asc" ? (
                            <img src={ArrowUp} alt="Ascending" />
                          ) : (
                            <img src={ArrowDown} alt="Descending" />
                          )}
                        </span>
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {equipments.map((equipment, index) => (
                <tr
                  key={equipment._id}
                  className={equipment.status ? "" : "disabled text-muted"}
                >
                  <td className="col">{index + 1}</td>
                  {visibleColumns.map((field, cellIndex) => (
                    <td key={cellIndex}>
                      {equipment[field.field_name] !== undefined &&
                        equipment[field.field_name] !== null ? (
                        <span title={equipment[field.field_name]}>
                          {truncateText(equipment[field.field_name], 15)}
                        </span>
                      ) : null}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* <div className="two-tables d-flex justify-content-between title-line row">
        <div className="table-one col">
          <h4 className="align-content-center m-0">
            &nbsp; Recent Lineage Templates
          </h4>
          <div className="table-responsive">
            <table className="table table-striped align-middle table-text">
              <thead className="table-head align-middle th-text">
                <tr>
                  <th className="col">#ID</th>
                  <th className="col">TEMPLATE NAME</th>
                  <th className="col">ACTION</th>
                </tr>
              </thead>
              <tbody className="tb-text">
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech Business - Priority</td>

                  <td
                    className="justify-content-center align-content-center gap-btwn-action"
                    style={{ paddingTop: "12px" }}
                  >
                    <div className="action-icons ps-2">
                      <span className="align-content-center ">
                        <a href="#">
                          <img src={visible} />
                        </a>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Aditya Birla - Sector </td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI </td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Aditya Birla Business - Plant 1</td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI</td>
                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Aditya Birla Business - Plant 2</td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI</td>
                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI</td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI</td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="table-two col title-line">
          <h4 className="align-content-center m-0">&nbsp; Add Equipment</h4>
          <div className="table-responsive">
            <table className="table table-striped align-middle table-text">
              <thead className="table-head align-middle th-text">
                <tr>
                  <th className="col">#ID</th>
                  <th className="col">TEMPLATE NAME</th>
                  <th className="col">ACTION</th>
                </tr>
              </thead>
              <tbody className="tb-text">
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech Business - Priority</td>

                  <td
                    className="justify-content-center align-content-center gap-btwn-action"
                    style={{ paddingTop: "12px" }}
                  >
                    <div className="action-icons ps-2">
                      <span className="align-content-center ">
                        <a href="#">
                          <img src={visible} />
                        </a>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Aditya Birla - Sector </td>
                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI </td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Aditya Birla Business - Plant 1</td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI</td>
                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Aditya Birla Business - Plant 2</td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI</td>
                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI</td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Lineage_UTCL</td>
                  <td>Ultra Tech - PRI</td>

                  <td>
                    <div className="action-icons ps-2">
                      <a className="align-content-center" href="#">
                        <img src={visible} />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Dashboard;
